<template>
  <legal-page
    title="Devoluciones, Reembolsos y Cancelaciones"
    intro="A continuación se detallan tus derechos y responsabilidades respecto a devoluciones, reembolsos y cancelaciones. Te recomendamos leer esta política antes de realizar un pago."
  >
    <div class="legal-sections">
      <legal-section
        step="01"
        title="Naturaleza del servicio"
        icon="RepeatIcon"
        variant="info"
      >
        <p>
          Los pagos realizados en este portal corresponden a servicios
          de telecomunicaciones de carácter recurrente (Internet,
          televisión por cable y telefonía) asociados a tu contrato
          con
          {{ business.name }}. El pago se aplica de inmediato al
          balance de tu cuenta.
        </p>
      </legal-section>

      <legal-section
        step="02"
        title="Reembolsos"
        icon="RotateCcwIcon"
        variant="success"
      >
        <p>
          Si se produce un cargo duplicado o incorrecto, puedes
          solicitar un reembolso dentro de los
          <strong>30 días</strong> posteriores a la transacción.
          Verificada la incidencia, el reembolso se procesa a la misma
          tarjeta utilizada, en un plazo estimado de 5 a 10 días
          hábiles según los tiempos del banco emisor.
        </p>
      </legal-section>

      <legal-section
        step="03"
        title="Cancelaciones"
        icon="XCircleIcon"
        variant="warning"
      >
        <p>
          Puedes solicitar la cancelación de tu servicio comunicándote
          con Servicio al Cliente. Los montos correspondientes a
          servicios ya consumidos no son reembolsables.
        </p>
      </legal-section>

      <legal-section
        step="04"
        title="Cómo solicitarlo"
        icon="MailIcon"
      >
        <p>
          Escríbenos a
          <a :href="`mailto:${business.email}`">{{
            business.email
          }}</a>
          o llámanos al
          <a :href="`tel:${business.phone}`">{{ business.phone }}</a>
          indicando el número de contrato y la referencia del pago.
        </p>
      </legal-section>
    </div>
  </legal-page>
</template>

<script>
import business from "@/business"
import LegalPage from "./LegalPage.vue"
import LegalSection from "./LegalSection.vue"

export default {
  components: { LegalPage, LegalSection },
  data() {
    return { business }
  },
}
</script>
